<template>
  <div class="evolution" @click="goPokemon(pokemon.identifier)">
    <img v-if="details" :src="$pkImg('small', details.identifier, details.id)" alt="" @error="$imgErr($event, 'sprite')">
    <p>{{pokemon.name}}</p>
    <!-- <pre>{{pokemon}}</pre> -->
    <!-- <template v-if="pokemon.evolution_details && Items.length">
      <div class="condition lvl" v-if="pokemon.evolution_details.minimum_level > 0">Lvl {{pokemon.evolution_details.minimum_level}}</div>
      <div class="condition item" v-if="pokemon.evolution_details.trigger_item_id != ''">Use {{Items[pokemon.evolution_details.trigger_item_id - 1].name}}</div>
      <div class="condition gender" :class="genders[pokemon.evolution_details.gender_id]" v-if="pokemon.evolution_details.gender_id != ''">{{genders[pokemon.evolution_details.gender_id].toTitle()}}</div>
    </template> -->
  </div>
</template>


<script>
import {mapGetters} from 'vuex'
import config from '../config'

export default {
  name: 'evolution',
  props: ['pokemon'],
  data() {
    return {
      genders: config.data.pokemon.genders,
    }
  },
  computed: {
    details() {
      for (let i = 0; i < this.PokemonList.length; i++) {
        if (this.PokemonList[i].species_identifier === this.pokemon.identifier) {
          return this.PokemonList[i]
        }
      }
      return null
    },
    ...mapGetters({
      PokemonList: 'pokemon/list',
      Items: 'item/list',
    })
  },
  methods: {
    goPokemon(identifier) {
      this.$router.push('/pokemon/' + identifier)
    },
  }
}
</script>

<style lang="scss" scoped>
pre {
  font-size: 10px;
}
.evolution {
  // in Pokemon.vue
}
p {
  font-weight: 700;
  line-height: 1;
}
.condition {
  background-color: #0a0a0a;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  // line-height: 15px;
  // border-radius: 4px;
  // display: inline-block;

  // max-width: 80%;
  // margin:auto;
  // border:1px solid rgba(0, 0, 0, .5);
  &:first-of-type {
    margin-top: 5px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom: none;
  }
  &:last-of-type {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top: none;
  }
  padding: 0 10px;
    background-color: #b12a2a;
  &.lvl {
    background-color: #b12a2a;
  }
  &.gender {
    background-color: #e8e8e8;
    color:#0071b7;
    &.female {
      color:#dc06dc;
    }
  }
  &.item {
    background-color: #f7f7f7;
    color: #000;
  }
}
</style>

